import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uploadICTImage, insertICTData, resetInsertSuccess, clearUploadPath } from '../../../../../store/uiSlice';
import { fetchDomains } from '../../../../../store/domainsSlice';
import { fetchVendors } from "../../../../../store/vendorsSlice";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "../../../../../Styles/Common.css";

const ICTDataInsert = () => {
    const dispatch = useDispatch();
    const { vendors = [], loading: vendorLoading } = useSelector((state) => state.vendors || {});
    const { loading, error, insertSuccess } = useSelector((state) => state.ui);
    const { domains, loading: domainLoading } = useSelector((state) => state.domains);

    const [formData, setFormData] = useState({
        ictName: '',
        ictDesc: '',
        ictSDesc: '',
        ictType: '',
        ictImg: null, // File object
        domainId: '', // Domain selection; if not set, we use the first domain
        vendorId: "",
    });

    const [uploadError, setUploadError] = useState('');

    useEffect(() => {
    dispatch(fetchDomains());
    dispatch(fetchVendors());
    }, [dispatch]);


    // Fetch domains on mount
    useEffect(() => {
        dispatch(fetchDomains());
    }, [dispatch]);

    // When insertSuccess occurs, reset the form (set default domain if available)
    useEffect(() => {
        if (insertSuccess) {
            alert('Data inserted successfully!');
            dispatch(resetInsertSuccess());
            dispatch(clearUploadPath());
            setFormData({
                ictName: '',
                ictDesc: '',
                ictSDesc: '',
                ictType: '',
                ictImg: null,
                domainId: domains && domains.length > 0 ? domains[0].id.toString() : '',
                vendorId: vendors && vendors.length > 0 ? vendors[0].id.toString() : "",
            });
        }
    }, [insertSuccess, dispatch, domains, vendors]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData(prev => ({ ...prev, ictImg: e.target.files[0] }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setUploadError('');

        console.log("Submitting formData:", formData);

        if (!formData.ictImg) {
            setUploadError('Please select an image to upload.');
            return;
        }

        // Use formData.domainId if set; otherwise, use the first domain's id if available.
        const domainIdValue =
            formData.domainId ||
            (domains && domains.length > 0 ? domains[0].id.toString() : '');
        const domainIdInt = parseInt(domainIdValue, 10);
        if (isNaN(domainIdInt) || domainIdInt <= 0) {
            setUploadError('Please select a valid domain.');
            return;
        }
        console.log("Using domainId:", domainIdInt);
            const vendorIdInt = formData.vendorId ? parseInt(formData.vendorId, 10) : null;
            if (formData.vendorId && (isNaN(vendorIdInt) || vendorIdInt <= 0)) {
            setUploadError("Please select a valid vendor.");
            return;
        }

        // Step 1: Upload the image
        dispatch(uploadICTImage(formData.ictImg))
            .unwrap()
            .then((data) => {
                // Step 2: Submit ICT data with the uploaded image path and valid domainId
                const payload = {
                    ictName: formData.ictName,
                    ictDesc: formData.ictDesc,
                    ictSDesc: formData.ictSDesc,
                    ictType: formData.ictType,
                    ictImg: data.filename,
                    domainId: domainIdInt,
                    vendorId: vendorIdInt,
                    status: "A", // Default active status
                };

                console.log("Dispatching insertICTData with payload:", payload);
                dispatch(insertICTData(payload));
            })
            .catch((err) => {
                console.error("Image upload failed:", err);
                setUploadError(err);
            });
    };

    return (
        <div className='container insertMain'>
            <div className="ict-data-insert-container">
                <h2>Insert New ICT Data</h2>
                {loading && <p className="loading">Processing...</p>}
                {error && <p className="error-message">Error: {error}</p>}
                {uploadError && <p className="error-message">Error: {uploadError}</p>}
                <form onSubmit={handleSubmit} className="ict-data-form">
                    <div className="form-group">
                        <label>ICT Name</label>
                        <input
                            type="text"
                            name="ictName"
                            value={formData.ictName}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Detailed Description</label>
                        <textarea
                            name="ictDesc"
                            rows="4"
                            value={formData.ictDesc}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Short Description</label>
                        <textarea
                            name="ictSDesc"
                            rows="2"
                            value={formData.ictSDesc}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Course Type</label>
                        <select
                            name="ictType"
                            value={formData.ictType}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Select Type</option>
                            <option value="Corporate Training">Corporate Training</option>
                            <option value="Industrial Training">Industrial Training</option>
                            <option value="Certificate Course">Certificate Course</option>
                            <option value="Internship">Internship</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Domain</label>
                        <select
                            name="domainId"
                            value={formData.domainId}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Select Domain</option>
                            {domainLoading ? (
                                <option value="">Loading Domains...</option>
                            ) : domains && domains.length > 0 ? (
                                domains.map((domain) => (
                                    <option key={domain.id} value={domain.id}>
                                        {domain.domain}
                                    </option>
                                ))
                            ) : (
                                <option value="">No domains available</option>
                            )}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Image</label>
                        <input
                            type="file"
                            name="ictImg"
                            accept="image/*"
                            onChange={handleFileChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                            <label>Vendor</label>
                            <select
                                name="vendorId"
                                value={formData.vendorId}
                                onChange={handleInputChange}
                            >
                                <option value="">Select Vendor (Optional)</option>
                                {vendorLoading ? (
                                <option value="">Loading Vendors...</option>
                                ) : vendors && vendors.length > 0 ? (
                                vendors.map((v) => (
                                    <option key={v.id} value={v.id}>
                                    {v.vendor}
                                    </option>
                                ))
                                ) : (
                                <option value="">No vendors available</option>
                                )}
                            </select>
                            </div>

                            <button type="submit" className="submit-btn" disabled={loading}>
                                Insert Data
                            </button>
                        </form>
                    </div>
            <div className="ict-data-insert-container">
                <h2>Instructions</h2>
                <ul>
                    <li>Keep ICT Name Simple and Trending as per demanding topics</li>
                    <li>Avoid any unnecessary special symbols and white spaces</li>
                    <li>Detailed description must be minimum 1000 Words</li>
                    <li>Short description must be maximum 250 Words</li>
                    <li>Image to be uploaded must be jpg/jpeg type only and should be under 1 mb</li>
                </ul>
            </div>
            <ToastContainer position="bottom-right" autoClose={3000} />
        </div>
    );
};

export default ICTDataInsert;
